const WORKSPACE_ROOTS = [
  '/ai-agent',
  '/dashboard',
  '/account-settings',
  '/brokerage-accounts',
  '/my-bots',
  '/my-backtests',
  '/my-strategies',
  '/charts',
  '/my-deployments',
  '/backtest',
  '/affiliate/dashboard',
];

/** Only workspace routes reserve navigation while a returning session resolves. */
export function isAuthenticatedWorkspacePath(pathname: string): boolean {
  return (
    ['/ai-bot-builder-bootcamp/watch', '/deploy', '/add-bot', '/video', '/onboarding'].includes(
      pathname,
    ) ||
    /^\/deployments\/[^/]+\/logs\/?$/.test(pathname) ||
    WORKSPACE_ROOTS.some((root) => pathname === root || pathname.startsWith(`${root}/`))
  );
}

export function shouldReserveAuthenticatedShell({
  pathname,
  authLoading,
  isAuthenticated,
  hasSessionHint,
}: {
  pathname: string;
  authLoading: boolean;
  isAuthenticated: boolean;
  hasSessionHint: boolean;
}): boolean {
  return (
    authLoading && !isAuthenticated && hasSessionHint && isAuthenticatedWorkspacePath(pathname)
  );
}
